import React from "react";
import { useModalLicenseAgreementHook } from "./modal-license-agreement-hooks";

type ContextModalLicenseAgreement = ReturnType<
  typeof useModalLicenseAgreementHook
>;
export const ModalLicenseAgreementContext =
  React.createContext<ContextModalLicenseAgreement | null>(null);

export function useContextModalLicenseAgreement() {
  const context = React.useContext(ModalLicenseAgreementContext);

  if (!context) {
    throw new Error(
      "useContextModalLicenseAgreement must be used within a ContextModalLicenseAgreementProvider",
    );
  }

  return context;
}
